"use client";

import { Box, Typography, Link } from "@mui/material";

export default function CertFAQ() {
  return (
    <Box
      sx={{
        mx: "auto",
        p: 3,
        bgcolor: "white",
        borderRadius: 2,
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        flex: 1,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          color: "rgb(15, 105, 185)",
          fontWeight: 500,
          mb: 3,
        }}
      >
        OpenCert FAQ
      </Typography>
      <Typography variant="h4" align="center" sx={{ mb: 6, fontWeight: 500 }}>
        Frequently Asked Questions
      </Typography>

      {/* General Section */}
      <Box sx={{ mb: 4 }}>
        <Typography
          variant="h6"
          sx={{
            color: "rgb(255, 170, 0)",
            mb: 3,
            fontWeight: 500,
          }}
        >
          General
        </Typography>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 500, mb: 1 }}>
              Who developed OpenCerts?
            </Typography>
            <Typography variant="body1">
              <Link
                href={process.env.GO_TECH_URL}
                target="_blank"
                color="primary"
              >
                GovTech Singapore
              </Link>{" "}
              developed OpenCerts in cooperation with the OpenCerts Consortium.
            </Typography>
          </Box>

          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 500, mb: 1 }}>
              What is OpenCerts?
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              OpenCerts is the umbrella trademark under which we have released a
              few key components:
            </Typography>
            <Box component="ul" sx={{ pl: 4, m: 0 }}>
              <li>
                <Typography variant="body1">
                  Open source schema for publishing educational credentials
                </Typography>
              </li>
              <li>
                <Typography variant="body1">
                  Tools for generating cryptographic protections for educational
                  credentials
                </Typography>
              </li>
              <li>
                <Typography variant="body1">
                  <Link
                    href={process.env.CERT_URL}
                    target="_blank"
                    color="primary"
                  >
                    This online website
                  </Link>{" "}
                  for verifying the authenticity of OpenCerts files.
                </Typography>
              </li>
            </Box>
          </Box>

          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 500, mb: 1 }}>
              Where do I get an OpenCerts certificate?
            </Typography>
            <Typography variant="body1">
              OpenCerts is an open-source platform. Please contact your
              educational institution's administrative office for inquiries
              about whether your certificate was issued in the OpenCerts format.
            </Typography>
          </Box>

          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 500, mb: 1 }}>
              Is my personal data safe on the blockchain?
            </Typography>
            <Typography variant="body1">
              Academic records of the certificate and personal data are not
              published on the blockchain. A hash is generated from the
              certificate and is used to prove that the certificate is
              legitimate.
            </Typography>
          </Box>

          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 500, mb: 1 }}>
              Why is OpenCerts backed by blockchain technology?
            </Typography>
            <Typography variant="body1">
              Blockchain greatly reduces the barrier to publishing
              cryptographically protected credentials compared to proprietary
              software. A public blockchain is accessible by anyone and does not
              require dedicated services to verify OpenCerts.
            </Typography>
          </Box>

          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 500, mb: 1 }}>
              Why use the Ethereum blockchain?
            </Typography>
            <Typography variant="body1">
              Ethereum is a widely used blockchain network with a large
              developer base and community support.
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Verifications Section */}
      <Box>
        <Typography
          variant="h6"
          sx={{
            color: "rgb(255, 170, 0)",
            mb: 3,
            fontWeight: 500,
          }}
        >
          Verifications
        </Typography>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 500, mb: 1 }}>
              What does it mean by Ethereum Blockchain?
            </Typography>
            <Typography variant="body1">
              The Ethereum Blockchain is a publicly usable distributed ledger
              based on blockchain technology, functioning like a publicly
              readable database.
            </Typography>
          </Box>

          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 500, mb: 1 }}>
              What does it mean by Revoked?
            </Typography>
            <Typography variant="body1">
              The issuer has explicitly published a notice of revocation for
              this certificate, and it is no longer valid.
            </Typography>
          </Box>

          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 500, mb: 1 }}>
              Is this safe to use? Can't anyone just copy my certificate file
              and pass off as me?
            </Typography>
            <Typography variant="body1">
              Yes, the certificate file can be duplicated, but the recipient's
              name in the certificate cannot be altered without failing the
              verification process.
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
